// extracted by mini-css-extract-plugin
export default {"homeSnapshotSection":"Home_homeSnapshotSection__X4aSP"};